import { useMutation, useQuery, useQueryClient } from "react-query";

import toast from "react-hot-toast";
import { UserService } from "./user.service";

// GET List
const useGetList = (page: number, option?: Object) => {
  return useQuery(
    ["listUser", page, option],
    async () => {
      const { data } = await UserService.getListUser({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true }
  );
};

const useGetListRestricted = (page: number) => {
  return useQuery(
    ["listUser", page],
    async () => {
      const { data } = await UserService.getListRestrictedUser({
        page,
      });
      return data;
    },
    { keepPreviousData: true }
  );
};

// CREATE
const useCreate = (cb?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (createdItem: any) => {
      try {
        const data = await UserService.createUser(createdItem);
        return data;
      } catch (error) {
        return error;
      }
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Create success! OK!");
          queryClient.invalidateQueries(["listUser"]);
        } else {
          toast.error(data?.errors[0]?.msg);
        }
      },
      onError(error) {
        toast.error((error as any)?.[0]?.msg);
      },
    }
  );
};

// UPDATE
const useUpdate = (cb?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (updatedItem: any) => {
      const data = await UserService.updateUser(updatedItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Update success! OK!");
          queryClient.invalidateQueries(["userDetail", data.data._id]);
          queryClient.invalidateQueries(["listUser"]);
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    }
  );
};

const useListAdmin = (params: TParams & { role_names?: string[] }) => {
  return useQuery(
    ["list_cpo_sp", params],
    async () => {
      const { data } = await UserService.getListAdmins(params);
      return data;
    },
    { keepPreviousData: true }
  );
};

const useUserDetail = (id: string) => {
  return useQuery(
    ["userDetail", id],
    async () => {
      const data = await UserService.getUserDetail(id);
      return data;
    },
    { enabled: !!id }
  );
};

const useTopUpByUser = (callback?: (data: any) => void) => {
  return useMutation(
    async (updatedItem: any) => {
      const dataTopUp = await UserService.topUpByUser(updatedItem);
      return dataTopUp;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Top up success!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        toast.error(error as string);
      },
    }
  );
};

const useRefundByTransaction = (callback?: (data: any) => void) => {
  return useMutation(
    async (updatedItem: any) => {
      const dataRefund = await UserService.refundByTransaction(updatedItem);
      return dataRefund;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Refund success!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error: any) {
        toast.error(error?.msg);
        return error;
      },
    }
  );
};

const useDeleteUser = (callback?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (userId: string) => {
      const dataDelete = await UserService.deleteUser(userId);
      return dataDelete;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Delete success!");
          queryClient.invalidateQueries(["listUser"]);
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error: any) {
        toast.error(error?.msg);
        return error;
      },
    }
  );
};

const useRestoreUser = (callback?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (userId: string) => {
      const dataRestore = await UserService.restoreUser(userId);
      return dataRestore;
    },
    {
      onSuccess: (data) => {
        callback?.(data);
        if (data.ok) {
          toast.success("Restore success!");
          queryClient.invalidateQueries(["listUser"]);
        } else {
          toast.error(data?.msg);
        }
      },
      onError: (error: any) => {
        toast.error(error?.msg);
        return error;
      },
    }
  );
};
export {
  useCreate,
  useDeleteUser,
  useGetList,
  useGetListRestricted,
  useListAdmin,
  useRefundByTransaction,
  useRestoreUser,
  useTopUpByUser,
  useUpdate,
  useUserDetail,
};
